import { isAxiosError } from "axios";
import { toast } from "react-toastify";
export function handleError(error) {
  if (isAxiosError(error)) {
    if (error.message === "canceled") {
      return;
    }
    if (error.response?.data.message) {
      toast.error(error.response.data.message);
    } else {
      toast.error(error.message);
    }
  } else {
    console.error("Error:", error);
  }
}

export function formatPrice(price, currency = "USD") {
  return parseFloat(price).toLocaleString("en-US", { style: "currency", currency: currency });
}

export const formatImageName = (value) => {
  if (!value) return null;
  const base =
    process.env.NODE_ENV === "production"
      ? "https://argetam.s3.ca-central-1.amazonaws.com"
      : "https://argetam.s3.ca-central-1.amazonaws.com";

  return `${base}/${value}`;
};

/**
 *
 * @param {number} price
 * @param {number} discount
 * @returns {number}
 */
export function calculateDiscountPrice(price, discount) {
  return price - price * (discount / 100);
}

export function formatNumber(amount) {
  if (amount >= 1_000_000_000) {
    return (amount / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
  } else if (amount >= 1_000_000) {
    return (amount / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  } else if (amount >= 1_000) {
    return (amount / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  return amount.toString();
}

export function formatString(value, length = 40) {
  if (typeof value !== "string") return "";

  return value.length > length ? `${value.slice(0, length)}...` : value;
}
